import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { BasicRegister } from 'src/app/models/basic-register.model';
import { BusinessUser } from 'src/app/models/business-user.model';
import { MgService } from 'src/app/services/mg.service';

@Component({
  selector: 'app-user-business-selection',
  templateUrl: './user-business-selection.component.html',
  styleUrls: ['./user-business-selection.component.scss']
})
export class UserBusinessSelectionComponent implements OnInit {
  @Input()
  set business (b: BasicRegister) {
    this._business = b;
    if(this._business != null) {
      this.listUserBusiness(this._business);
    }
  }

  @Output()
  userBusinessSelected: EventEmitter<BusinessUser> = new EventEmitter<BusinessUser>()

  private _business: BasicRegister;
  private _userBusiness: BusinessUser;
  public _loading: boolean = false;
  public callUserForm: UntypedFormGroup;
  public items: BusinessUser[] = [];
  public displayedColumns: string[] = ['id', 'name', 'email', 'mobile', 'options'];

  constructor(
    private fb: UntypedFormBuilder,
    public api: MgService,
  ) { }

  ngOnInit(): void {
    this.callUserForm = this.fb.group({
      id: [undefined],
      business_id: [undefined, [Validators.required]],
      name: [undefined, [Validators.required]],
      email: [undefined, [Validators.required, Validators.email]],
      mobile: [undefined]//, [Validators.pattern("[0-9]{11}")]]
    })
  }

  public listUserBusiness(business: BasicRegister) {
    this._loading = true;
    this.api.listBusinessUser(business.id.toString())
      .subscribe(
        res => {
          this.items = res.data;
        },
        err => {
          console.error(err);
          this._loading = false;
        },
        () => this._loading = false,
      );
  }

  public onSubmit() {
    this._loading = true;
    this.callUserForm.controls.business_id.setValue(this._business.id);
    this.api.createBusinessUser(this.callUserForm.value)
    .subscribe(
      res => {
        this.selectUserBusiness(res.data);
      },
      err => {
        console.error(err);
        this._loading = false;
      },
      () => this._loading = false,
    );
  }

  public selectUserBusiness(value) {
    this._userBusiness = value;
    this.userBusinessSelected.emit(this._userBusiness)
  }
}
